export default function displayIf(shouldDisplay: boolean) {
    return {display: shouldDisplay ? 'inline' : 'none'}
}